import { useCallback } from "react";
import styles from "./size-preset-inline-menu.module.css";
import { SizePreset } from "PosterEditor/model/size-presets/size-preset";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { formatPrice } from "./size-preset-utils";

interface Props {
  sizePresets: SizePreset[];
  selectedPreset: SizePreset | undefined;
  onSelectPreset: (preset: SizePreset) => void;
  disabled?: boolean;
}

export const SizePresetInlineMenu = ({
  sizePresets,
  selectedPreset,
  onSelectPreset,
  disabled,
}: Props) => {
  const handleSelectPreset = useCallback(
    (preset: SizePreset) => {
      if (!disabled) {
        onSelectPreset(preset);
      }
    },
    [onSelectPreset, disabled]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.scrollContainer}>
        <div className={styles.optionsRow}>
          {sizePresets.map((preset) => {
            const isSelected = selectedPreset?.id === preset.id;
            return (
              <button
                key={preset.id}
                className={filterClasses(
                  styles.sizeCard,
                  isSelected ? styles.sizeCardSelected : "",
                  disabled ? styles.disabled : ""
                )}
                onClick={() => handleSelectPreset(preset)}
                disabled={disabled}
              >
                <div className={styles.cardContent}>
                  <span className={styles.sizeDescription}>
                    {preset.sizeDescription}
                  </span>
                  {preset.materialDescription && (
                    <span className={styles.materialDescription}>
                      {preset.materialDescription}
                    </span>
                  )}
                  {preset.priceInt && (
                    <span className={styles.price}>
                      {formatPrice(preset.priceInt)}
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
